import { create } from 'zustand';

interface TenantState {
  tenantSlug: string | null;
  tenantName: string | null;

  setTenant: (slug: string, name?: string) => void;
  initFromHostname: () => void;
}

function extractSlugFromHostname(): string | null {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Subdomain pattern: {slug}.churchcrm.app or {slug}.localhost
  if (parts.length >= 2 && parts[0] !== 'www' && parts[0] !== 'app') {
    return parts[0] ?? null;
  }

  // Fallback: check localStorage (Capacitor / mobile)
  return localStorage.getItem('tenant_slug');
}

export const useTenantStore = create<TenantState>((set) => ({
  tenantSlug: extractSlugFromHostname(),
  tenantName: localStorage.getItem('tenant_name'),

  setTenant: (slug: string, name?: string) => {
    localStorage.setItem('tenant_slug', slug);
    if (name) {
      localStorage.setItem('tenant_name', name);
    }
    set({ tenantSlug: slug, tenantName: name ?? null });
  },

  initFromHostname: () => {
    const slug = extractSlugFromHostname();
    if (slug) {
      set({ tenantSlug: slug });
    }
  },
}));
